import { defineMessages } from 'react-intl';

// Central constant for max_length default and helpers
export const DEFAULT_MAX_LENGTH = 255;

export function normalizeMaxLength(value) {
  if (value === undefined || value === null || value === '')
    return DEFAULT_MAX_LENGTH;
  const n = Number(value);
  return Number.isNaN(n) ? DEFAULT_MAX_LENGTH : n;
}

// i18n messages for the max_length schema field
const messages = defineMessages({
  field_max_length: {
    id: 'form_field_max_length',
    defaultMessage: 'Maximum length',
  },
  field_max_length_description: {
    id: 'form_field_max_length_description',
    defaultMessage:
      'The maximum number of characters the user will be able to input.Use 0 for no limit.',
  },
});

export const MAX_LENGTH_FIELD = 'max_length';

export const getMaxLengthProperty = (intl) => ({
  title: intl.formatMessage(messages.field_max_length),
  description: intl.formatMessage(messages.field_max_length_description),
  type: 'number',
  default: DEFAULT_MAX_LENGTH,
});

export default DEFAULT_MAX_LENGTH;
